
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $22de11b45b0eeb97$exports = {};

$parcel$export($22de11b45b0eeb97$exports, "Defer", function () { return $22de11b45b0eeb97$export$c7e91f8aec23ae14; });
$parcel$export($22de11b45b0eeb97$exports, "makeDefer", function () { return $22de11b45b0eeb97$export$51ca94569b882c51; });
class $22de11b45b0eeb97$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $22de11b45b0eeb97$export$51ca94569b882c51 = ()=>new $22de11b45b0eeb97$export$c7e91f8aec23ae14();


var $e3640f413e0c36e7$exports = {};

$parcel$export($e3640f413e0c36e7$exports, "Observable", function () { return $e3640f413e0c36e7$export$77cea355fa80b5f4; });

if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $e3640f413e0c36e7$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new (0, $22de11b45b0eeb97$export$c7e91f8aec23ae14)()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new (0, $22de11b45b0eeb97$export$c7e91f8aec23ae14)());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}


var $603f33a01a36ab56$exports = {};

$parcel$export($603f33a01a36ab56$exports, "createQueue", function () { return $603f33a01a36ab56$export$d16acf4b6e75743d; });


function $603f33a01a36ab56$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new (0, $e3640f413e0c36e7$export$77cea355fa80b5f4)(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new (0, $22de11b45b0eeb97$export$c7e91f8aec23ae14)();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}




export {$22de11b45b0eeb97$export$c7e91f8aec23ae14 as Defer, $22de11b45b0eeb97$export$51ca94569b882c51 as makeDefer, $e3640f413e0c36e7$export$77cea355fa80b5f4 as Observable, $603f33a01a36ab56$export$d16acf4b6e75743d as createQueue};
//# sourceMappingURL=index.esm.js.map
